import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Calculator from "@/pages/Calculator";
import Scenarios from "@/pages/Scenarios";
import ScenarioDetail from "@/pages/ScenarioDetail";
import Settings from "@/pages/Settings";
import Leads from "@/pages/Leads";
import Compare from "@/pages/Compare";
import QuickBreakdown from "@/pages/QuickBreakdown";
import Examples from "@/pages/Examples";
import Pricing from "@/pages/Pricing";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Header from "@/components/Header";
import SiteFooter from "@/components/SiteFooter";

axios.defaults.withCredentials = true;

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-brand-bone text-brand-ink">
      <Header />
      <div className="flex-1">{children}</div>
      <SiteFooter />
    </div>
  );
}

function Protected({ children, adminOnly = false }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id BEFORE normal routing (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Layout><Landing /></Layout>} />
      <Route path="/login" element={<Layout><Login /></Layout>} />
      <Route path="/advisor-login" element={<Layout><Login /></Layout>} />
      <Route path="/examples" element={<Layout><Examples /></Layout>} />
      <Route path="/quick-breakdown" element={<Layout><QuickBreakdown /></Layout>} />
      <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
      <Route path="/terms" element={<Layout><Terms /></Layout>} />
      <Route path="/calculator" element={<Protected><Calculator /></Protected>} />
      <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
      <Route path="/pricing/success" element={<Protected><CheckoutSuccess /></Protected>} />
      <Route path="/scenarios" element={<Protected><Scenarios /></Protected>} />
      <Route path="/scenarios/compare" element={<Protected><Compare /></Protected>} />
      <Route path="/scenarios/:id" element={<Protected><ScenarioDetail /></Protected>} />
      <Route path="/leads" element={<Protected><Leads /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}
